module.exports = __webpack_public_path__ + "assets/img/join-back-01.cba4dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/join-back-01.png
// module id = 47uZ
// module chunks = 1